import { createAction } from '@reduxjs/toolkit';
import * as actionTypes from './actionTypes';

export const setAuth = createAction<{
  field: FlattenKeys<AuthState>;
  value: any;
}>(actionTypes.SET_AUTH);

export const setToken = createAction<GetTokenResponse>(actionTypes.SET_TOKEN);

export const setProfile = createAction<GetProfileResponse>(
  actionTypes.SET_PROFILE,
);

export const authenticated = createAction<void>(actionTypes.AUTHENTICATED);

export const resetAuth = createAction<void>(actionTypes.RESET_AUTH);

const authActions = (dispatch: <T>(action: any) => T) =>
  Object.assign(
    {},
    {
      setAuth: <T extends FlattenKeys<AuthState>>(
        field: T,
        value: DeepType<AuthState, T>,
      ) => dispatch<void>(setAuth({ field, value })),
      setToken: (payload: GetTokenResponse) =>
        dispatch<void>(setToken(payload)),
      setProfile: (payload: GetProfileResponse) =>
        dispatch<void>(setProfile(payload)),
      authenticated: (payload: void) => dispatch<void>(authenticated(payload)),
      resetAuth: () => dispatch<void>(resetAuth()),
    },
  );

export default authActions;
